import script from "./LoyaltyPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoyaltyPopup.vue?vue&type=script&setup=true&lang=ts"

import "./LoyaltyPopup.vue?vue&type=style&index=0&id=242f120b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242f120b"]])

export default __exports__